// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3mxh5","alert":"SettungsInbox_alert__13tHI"};